<template>
  <div class="container-fluid">
    <h3 class="text-light mt-5">Нарушения</h3>
    <br>
    <input type="text" class="form-control bg-dark border-dark text-white" v-model="filter" placeholder="Поиск"/>
    <br>
      <table class="table table-dark table-hover mt-2" v-if="!loading">
        <thead>
        <tr>
          <th>
            <a class="text-white nowrap" href="" @click.prevent="setSort('DATE')">
              Дата
              <span v-if="isSort('DATE') !== 0">
                <font-awesome-icon :icon="['fas', 'arrow-up']" v-if="isSort('DATE') === 1"></font-awesome-icon>
                <font-awesome-icon :icon="['fas', 'arrow-down']" v-if="isSort('DATE') === -1"></font-awesome-icon>
              </span>
            </a>
          </th>
          <th>
            <a class="text-white nowrap" href="" @click.prevent="setSort('INFRINGEMENT_TYPE_FK')">
              Тип нарушения
              <span v-if="isSort('INFRINGEMENT_TYPE_FK') !== 0">
                <font-awesome-icon :icon="['fas', 'arrow-up']" v-if="isSort('INFRINGEMENT_TYPE_FK') === 1"></font-awesome-icon>
                <font-awesome-icon :icon="['fas', 'arrow-down']" v-if="isSort('INFRINGEMENT_TYPE_FK') === -1"></font-awesome-icon>
              </span>
            </a>
          </th>
          <th v-show="userPpe === null" >
            <a class="text-white nowrap" href="" @click.prevent="setSort('CODE_PPE_OGE')">
              Код
              <span v-if="isSort('CODE_PPE_OGE') !== 0">
                <font-awesome-icon :icon="['fas', 'arrow-up']" v-if="isSort('CODE_PPE_OGE') === 1"></font-awesome-icon>
                <font-awesome-icon :icon="['fas', 'arrow-down']" v-if="isSort('CODE_PPE_OGE') === -1"></font-awesome-icon>
              </span>
            </a>
          </th>
          <th v-show="userPpe === null">
            <a class="text-white nowrap" href="" @click.prevent="setSort('SCHOOL_FK')">
              ППЭ
              <span v-if="isSort('SCHOOL_FK') !== 0">
                <font-awesome-icon :icon="['fas', 'arrow-up']" v-if="isSort('SCHOOL_FK') === 1"></font-awesome-icon>
                <font-awesome-icon :icon="['fas', 'arrow-down']" v-if="isSort('SCHOOL_FK') === -1"></font-awesome-icon>
              </span>
            </a>
          </th>
          <th>
            <a class="text-white nowrap" href="" @click.prevent="setSort('CLASSROOM_FK')">
              Аудитория
              <span v-if="isSort('CLASSROOM_FK') !== 0">
                <font-awesome-icon :icon="['fas', 'arrow-up']" v-if="isSort('CLASSROOM_FK') === 1"></font-awesome-icon>
                <font-awesome-icon :icon="['fas', 'arrow-down']" v-if="isSort('CLASSROOM_FK') === -1"></font-awesome-icon>
              </span>
            </a>
          </th>
          <th>
            <a class="text-white nowrap" href="" @click.prevent="setSort('POSITION')">
              Место
              <span v-if="isSort('POSITION') !== 0">
                <font-awesome-icon :icon="['fas', 'arrow-up']" v-if="isSort('POSITION') === 1"></font-awesome-icon>
                <font-awesome-icon :icon="['fas', 'arrow-down']" v-if="isSort('POSITION') === -1"></font-awesome-icon>
              </span>
            </a>
          </th>
          <th>
            <a class="text-white nowrap" href="" @click.prevent="setSort('STATUS_INFRINGEMENT')">
              Статус
              <span v-if="isSort('STATUS_INFRINGEMENT') !== 0">
                <font-awesome-icon :icon="['fas', 'arrow-up']" v-if="isSort('STATUS_INFRINGEMENT') === 1"></font-awesome-icon>
                <font-awesome-icon :icon="['fas', 'arrow-down']" v-if="isSort('STATUS_INFRINGEMENT') === -1"></font-awesome-icon>
              </span>
            </a>
          </th>
        </tr>
        </thead>
        <tbody>
        <template v-if="total > 0">
          <tr v-for="(item, key) in items" :key="key" @click="$router.push({ name: 'Contravention' , params : { id : item.SYS_GUID }})" :class="{'table-active' : $route.params.id === item.SYS_GUID, 'bg-primary-alpha' : item.STATUS_INFRINGEMENT === 'sent', 'bg-primary-alpha-2' : item.STATUS_INFRINGEMENT === 'returned' }">
            <td>{{ item.DATE }}</td>
            <td><template v-if="item.INFRINGEMENT_TYPE_FK">{{ item.INFRINGEMENT_TYPE_FK['display'] }}</template><template v-else>не указано</template></td>
            <td v-show="userPpe === null">{{ item.CODE_PPE_OGE }}</td>
            <td v-show="userPpe === null"><template v-if="item.SCHOOL_FK">{{ item.SCHOOL_FK['display'] }}</template><template v-else>не указано</template></td>
            <td><template v-if="item.CLASSROOM_FK">{{ item.CLASSROOM_FK['display'] }}</template><template v-else>не указано</template></td>
            <td>{{ item.POSITION }}</td>
            <td>
            <span v-if="item.STATUS_INFRINGEMENT" :class="{'text-danger' : item.STATUS_INFRINGEMENT === 'sent', 'text-warning' : item.STATUS_INFRINGEMENT === 'returned'}">
              {{ statuses[item.STATUS_INFRINGEMENT] }}
            </span>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td :colspan="userPpe === null ? 5 : 6" class="py-4 text-center"><i>Нет данных</i></td>
          </tr>
        </template>
        </tbody>
      </table>
      <div class="text-white text-center my-5" v-else>
        Загрузка...
      </div>
      <pager :items="total" :page="page" :limit="ppage" @setPage="page = $event" @setPerPage="ppage = $event"></pager>
    <b-sidebar
      id="sidebar-backdrop"
      backdrop-variant="dark"
      backdrop
      shadow
      right
      :visible="open"
      width="50%"
      bg-variant="dark"
      text-variant="light"
      no-close-on-route-change
      class="p-2"
      lazy
      @hidden="$router.push({ name : 'List' })"
    >
      <router-view @processed="loadItems()"></router-view>
    </b-sidebar>

  </div>
</template>

<script>
  import { apiQuery } from "../api";
  import Vuex from 'vuex'
  import Pager from '@/components/Pager'
  import _ from "lodash"

  export default {
    name: "List",
    components: { Pager },
    data() {
      return {
        loading: true,
        items: [],
        filter: '',
        page: 1,
        ppage: 20,
        total: 0,
        tick: null,
        sort: [{
          field: 'DATE',
          dir: 'DESC'
        }]
      }
    },
    computed: {
      ...Vuex.mapGetters([
        'isAdmin',
        'role',
        'userPpe'
      ]),
      statuses() {
        return window.x2.violation
      },
      open() {
        return this.$route.name !== 'List'
      },
      multiSort() {
        return window.x2.multiSort
      }
    },
    watch: {
      filter: {
        handler () {
          this.loading = true
          setTimeout(() => { this.loadItems() }, 100)
        }
      },
      page: {
        handler () {
          this.loading = true
          this.loadItems()
        }
      },
      ppage: {
        handler () {
          this.loading = true
          this.loadItems()
        }
      },
      sort: {
        handler () {
          this.loading = true
          this.loadItems()
        },
        deep: true
      }
    },
    mounted() {
      this.loadItems()
      if (this.userPpe !== null)
        this.tick = setInterval(() => { this.loadItems() }, 120000)
    },
    beforeDestroy() {
      if (this.userPpe !== null)
        clearInterval(this.tick)
    },
    methods: {
      isSort(column) {
        let item = _.find(this.sort, {field : column})
        if (!item)
          return 0
        if (Object.prototype.hasOwnProperty.call(item,'dir')) {
          return item.dir === 'ASC' ? 1 : -1
        }
        else
          return 0
      },
      setSort(column) {
        let item = _.find(this.sort, {field : column})
        if (this.multiSort) {
          if (!item) {
            this.sort.push({
              field : column,
              dir: 'ASC'
            })
          }
          else {
            if (!Object.prototype.hasOwnProperty.call(item,'dir')) {
              item.dir = 'ASC'
              return
            }
            if (item.dir === 'ASC') {
              item.dir = 'DESC'
            }
            else {
              this.$delete(this.sort, this.sort.indexOf(item))
            }
          }
        }
        else {
          if (!item) {
            this.$set(this.sort, 0, {
              field : column,
              dir: 'ASC'
            })
          }
          else {
            if (item.dir === 'ASC') {
              item.dir = 'DESC'
            }
            else if (item.dir === 'DESC') {
              item.dir = 'ASC'
            }
          }
        }
      },
      loadItems() {
        let params = {
          table: window.x2.tables.violations,
          offset: (this.page - 1) * this.ppage,
          limit: this.ppage
        }
        if (this.filter.length > 0) {
          params['searchFields'] = ['DATE', 'COMMENT', 'SCHOOL_FK', 'INFRINGEMENT_TYPE_FK', 'CLASSROOM_FK']
          params['simpleSearch'] = this.filter
        }
        if (this.role === 'ppe' && this.userPpe !== null) {
          params["filters"] = [
            {
              "type": "simple",
              "operator": "eq",
              "field": "SCHOOL_FK",
              "value": this.userPpe
            }
          ]
        }
        params['sort'] = this.sort
        apiQuery('private', 'data-get-records', params, false).then(response => {
          this.total = response.count
          let items = response.rows
          if (process.env.NODE_ENV === 'development')
            items.map(i => { i.LINK_VIDEO = i.LINK_VIDEO.replace('https://smotrigia.pskovedu.ru', '')})
          this.items = items
          this.loading = false
        })
      }
    }
  }
</script>

